.btn {
    margin-left: 1rem;
}
